"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestErrors = void 0;
exports.requestErrors = {
    status: 400,
    updatedDraftColumns: [],
    errors: [
        {
            errorType: "Reference Validation Error",
            errorMessage: "Reference value not found",
            columnInError: "Body Region",
            valueInError: "chest",
            mappedDictionaryOrganizationName: "CodaMetrix",
            mappedParentDictionaryOrganizationName: null,
            mappedDictionaryName: "Body Region",
            mappedDictionaryLookupColumn: "Body Region",
            mappedDictionaryTenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
            requestId: null
        },
        {
            errorType: "Reference Validation Error",
            errorMessage: "Reference value not found",
            columnInError: "Procedure Type Category",
            valueInError: "ct",
            mappedDictionaryOrganizationName: "CodaMetrix",
            mappedParentDictionaryOrganizationName: null,
            mappedDictionaryName: "Procedure Type Categories",
            mappedDictionaryLookupColumn: "Abbreviation",
            mappedDictionaryTenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
            requestId: null
        },
        {
            errorType: "Reference Validation Error",
            errorMessage: "Reference value not found",
            columnInError: "Procedure Types",
            valueInError: "computed tomography",
            mappedDictionaryOrganizationName: "CodaMetrix",
            mappedParentDictionaryOrganizationName: null,
            mappedDictionaryName: "Procedure Types",
            mappedDictionaryLookupColumn: "Procedure Types",
            mappedDictionaryTenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
            requestId: null
        },
        {
            errorType: "Reference Validation Error",
            errorMessage: "Reference value not found",
            columnInError: "Work Queue",
            valueInError: "CT LOWER EXTREMITY",
            mappedDictionaryOrganizationName: "Mass General Brigham",
            mappedParentDictionaryOrganizationName: null,
            mappedDictionaryName: "Work Queue",
            mappedDictionaryLookupColumn: "Work Queue",
            mappedDictionaryTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
            requestId: null
        },
        {
            errorType: "Reference Validation Error",
            errorMessage: "Reference value not found",
            columnInError: "CPT Code",
            valueInError: "G0000",
            mappedDictionaryOrganizationName: "CodaMetrix",
            mappedParentDictionaryOrganizationName: null,
            mappedDictionaryName: "CPT Codes",
            mappedDictionaryLookupColumn: "Code",
            mappedDictionaryTenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
            requestId: null
        },
        {
            errorType: "Reference Validation Error",
            errorMessage: "Reference value not found",
            columnInError: "Modifier",
            valueInError: "ICW",
            mappedDictionaryOrganizationName: "Mass General Brigham",
            mappedParentDictionaryOrganizationName: "Codametrix",
            mappedDictionaryName: "Modifiers",
            mappedDictionaryLookupColumn: "Code",
            mappedDictionaryTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
            requestId: null
        }
    ]
};
//# sourceMappingURL=request-errors.js.map